import { useState } from "react";
import SoftBox from "components/SoftBox";
import SlugTabs from "cxfcomponents/SlugTabs";
import useSlugSchedule from "hooks/useSlugSchedule";
import Overview from "./components/Overview";
import { Flows } from "./components/Flows";

const tabsData = ["overview", "flows"];

const ScheduleTabs = () => {
  const { schedule } = useSlugSchedule();
  const [currentTab, setCurrentTab] = useState("overview");

  const renderTab = () => {
    switch (currentTab) {
      case "overview":
        return <Overview schedule={schedule} />;
      case "users":
        return <>User</>;
      case "flows":
        return <Flows schedule={schedule} />;
    }

    return <></>;
  };

  if (!schedule?.id) return <></>;

  return (
    <SoftBox>
      <SoftBox paddingBottom="24px">
        <SlugTabs tabs={tabsData} value={currentTab} onChange={setCurrentTab} />
        {renderTab()}
      </SoftBox>
    </SoftBox>
  );
};

export default ScheduleTabs;
